import { addMonths, subMonths } from 'date-fns'
import type { VFC } from 'react'
import { Button, ButtonSize } from '../../Button'
import { Icon } from '../../Icon'
import { useCalendar } from '../useCalendar'
import { UseCalendarDatesValue } from '../useCalendar/useCalendarDates'
import { MonthPicker, YearPicker } from './jumpPickers'
import * as styles from './styles'

export type MonthSelectorProps = {
  focusDate: Date
  setFocusDate: UseCalendarDatesValue['setFocusDate']
}

/**
 * Controls to let the user navigate to the next or previous month, or jump
 * directly to another year or another month in the current year. Preserves the
 * selected day of month when navigating.
 */
export const MonthSelector: VFC<MonthSelectorProps> = ({
  focusDate,
  setFocusDate,
}) => {
  const { locale } = useCalendar()

  return (
    <div className={styles.selectors.container} css={styles.container}>
      <div className={styles.selectors.pickers}>
        <MonthPicker
          locale={locale}
          onChange={setFocusDate}
          focusDate={focusDate}
        />
        <YearPicker
          locale={locale}
          onChange={setFocusDate}
          focusDate={focusDate}
        />
      </div>
      <div className={styles.selectors.nextPrevious}>
        <Button
          ariaLabel="Navigate to previous month"
          variant="tertiary"
          hideButtonText={true}
          icon={<Icon ariaMode="hidden" glyph="gem-chevron-w" />}
          name="previous-month"
          onClick={() => setFocusDate(subMonths(focusDate, 1))}
          size={ButtonSize.Small}
        />
        <Button
          ariaLabel="Navigate to next month"
          variant="tertiary"
          hideButtonText={true}
          icon={<Icon ariaMode="hidden" glyph="gem-chevron-e" />}
          name="next-month"
          onClick={() => setFocusDate(addMonths(focusDate, 1))}
          size={ButtonSize.Small}
        />
      </div>
    </div>
  )
}
MonthSelector.displayName = 'Lapidary: MonthSelector ← Calendar'
